import { render } from "./MenuContexto.vue?vue&type=template&id=22b0b6ce"
import script from "./MenuContexto.vue?vue&type=script&lang=js"
export * from "./MenuContexto.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bhfagundes/Desktop/mobs2/operacoes-front-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__